/* eslint-disable */
import axios from 'axios';
import jsonapiParse from 'jsonapi-parse';
import qs from 'qs';
import fallbacks from './fallbacks';
import params from './params';

const htmlLang = document.documentElement.lang;
const locale = htmlLang ? htmlLang.split('-')[0] : 'fr';
const getLangPrefix = () => (locale !== 'fr' ? locale : '');
const paramsSerializer = (params) => {
    return params ? qs.stringify(params, { arrayFormat: 'indices' }) : '';
};
const instance = axios.create({
    baseURL: `/${getLangPrefix()}`,
    timeout: 10000,
    paramsSerializer,
});
instance.CancelToken = axios.CancelToken;
instance.interceptors.response.use(
    (response) => {
        if (
            response &&
            response.data &&
            response.data.router &&
            response.data.router.body &&
            response.data.router.body
        ) {
            const body = JSON.parse(response.data.router.body);
            if (response.data.router.headers.status[0] >= 400) {
                throw new Error(body.message || 'CMS error');
            }
            if (body.redirect) {
                window.location.href = body.redirect[0].to;
                return;
            }
        }
        return response.config.jsonApiParse !== false ? jsonapiParse.parse(response.data) : response.data;
    },
    (error) => {
        if (error.response) {
            if (!error.config.continueOnFailure) {
                throw new Error(
                    `${error.response.status} - ${error.response.statusText}`
                );
            }
        } else if (['ECONNABORTED', 'ENOTFOUND'].includes(error.code) || error.message === 'Network Error') {
            if (!error.config.continueOnFailure) {
                throw new Error('Service indisponible');
            } else if (error.config.showWarningOnFailure) {
                // @TODO: Reconduire le message d'erreur vers le store pour
                // l'affichage dans le header
                // ctx.app.store.commit('SET_SITE_WARNING', {
                //     code: 'api_unavail',
                // });
                console.warn('[API warning] Service indisponible');
            }
        } else if (error.config && !error.config.continueOnFailure) {
            throw new Error(error.error || 'Erreur serveur');
        }
        return Promise.reject(error.response);
    },
);

let source;

export default {
    // /**
    //  * Instance de axios avec des paramètres par défaut.
    //  * @type {Object}
    //  */
    axios: instance,
    params: params(),
    fallbacks: fallbacks(),
    async getAllNoticesV2() {
        const notices = await this.axios.get('/api/notices_v2', {
            params: this.params.noticesV2(),
            continueOnFailure: true,
        });
        return notices && notices.data ? notices.data : [];
    },
    async getAutocompleteStops(noStop) {
        if (!noStop || noStop === '') return [];
        if (source) source.cancel();
        source = axios.CancelToken.source();
        const results = await this.axios.get('api/search-stops', {
            cancelToken: source.token,
            params: {
                search: noStop,
                location: {
                    distance: {
                        from: 500,
                    },
                    value: '',
                },
                sort_field: 'search_api_relevance',
                sort_direction: 'ASC',
            },
            continueOnFailure: true,
        });
        return results && results.results;
    },
    /**
     * Récupère les arrêts près d'une position
     * @param  {String}   location  (optionnel) Coordonnées du point à partir duquel chercher les arrêts dans un rayon précisé
     * @return {Promise}            Liste des arrêts correspondants
     */
    async getNearbyStops(location = '') {
        const results = await this.axios.get('api/search-stops', {
            params: {
                location: {
                    distance: {
                        from: 1,
                    },
                    value: location,
                },
                sort_field: 'search_api_relevance',
                sort_direction: 'ASC',
            },
            continueOnFailure: true,
        });
        return results && results.results;
    },
    /**
     * Retourne la liste des points de vente selon les filtres appliqués
     * @param  {string}       terms  (optionnel) Termes de recherche (seulement sur le nom du point de vente)
     * @param  {int}       distance  Rayon de recherche en mètres (ex: 500)
     * @param  {string}    location  Coordonnées de l'adresse recherchée (ex: 46.785163272946,-71.286588112053)
     * @param  {int} items_per_page  Nombre d'items à afficher (valeurs possibles: 10, 25, 30, 50, 100, 200)
     * @param  {int}           page  Numéro de la page à charger (valeurs possible à calculer à partir du nombre de résultats et items_per_page)
     * @return {Promise(array)}      Liste des points de vente
     */
    async getPointsOfSale(search, location, filters) {
        const results = await this.axios.get('/api/search-points-of-sale', {
            params: {
                search: search || '',
                location: {
                    distance: {
                        from: 500,
                    },
                    value: location,
                },
                items_per_page: 200,
                page: 0,
                f: filters,
                sort: 'geodist() asc',
            },
        });
        return results;
    },
    subscribeToNewsletter(fields) {
        return this.axios.post('/api/newsletter/subscribe', fields, {
            continueOnFailure: true,
        });
    },
};
